import throttle from 'lodash/throttle';

const errorThreshold = 1; // in px
let initialized = false;
let elements;
let remains;

function init() {
	initialized = true;
	elements = document.querySelectorAll('.agsoz-card__inner-wrapper');
	update();
}

function update() {
	if (!initialized) {
		init();
		return;
	}

	if (elements.length === 0) {
		return;
	}

	remains = [...elements].map(el => ({top: null, height: null, el: el}));
	// remove all height before
	remains.forEach(item => {
		item.el.style.minHeight = '';
	});

	process();
}

function process() {
	remains.forEach((item) => {
		const bb = item.el.getBoundingClientRect();
		item.top = bb.top;
		item.height = bb.height;
	});

	remains.sort((a, b) => a.top - b.top);

	const processingTop = remains[0].top;
	const processingTargets = remains.filter(item => Math.abs(item.top - processingTop) <= errorThreshold);
	const maxHeightInRow = Math.max(...processingTargets.map(item => item.height));

	processingTargets.forEach((item) => {
		const error = processingTop - item.top + errorThreshold;
		item.el.style.minHeight = `${maxHeightInRow + error}px`;
	});

	remains.splice(0, processingTargets.length);

	if (remains.length > 0) {
		process();
	}
}

init();
window.addEventListener('resize', throttle(update, 200));
